import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../enviroment/enviroment';
import {
  GuestReservationRequest,
  GuestReservationResponse,
  ApiError
} from '../models/guest-reservation.model';

@Injectable({
  providedIn: 'root'
})
export class GuestReservationService {
  private http = inject(HttpClient);

  // 🔗 Usa la URL del environment configurado
  private readonly API_BASE_URL = environment.apiUrl;

  /**
   * Crea una solicitud de reserva pública (sin autenticación)
   */
  createReservation(data: GuestReservationRequest): Observable<GuestReservationResponse> {
    return this.http.post<GuestReservationResponse>(
      `${this.API_BASE_URL}/reservations`,
      data
    ).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Valida que las fechas sean válidas
   */
  validateDates(checkIn: Date, checkOut: Date): { valid: boolean; error?: string } {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    if (checkIn < today) {
      return { valid: false, error: 'La fecha de entrada no puede ser en el pasado' };
    }

    if (checkOut <= checkIn) {
      return { valid: false, error: 'La fecha de salida debe ser posterior a la entrada' };
    }

    return { valid: true };
  }

  /**
   * Calcula el número de noches entre dos fechas
   */
  calculateNights(checkIn: Date, checkOut: Date): number {
    const diff = checkOut.getTime() - checkIn.getTime();
    const nights = Math.ceil(diff / (1000 * 3600 * 24));
    return nights > 0 ? nights : 0;
  }

  /**
   * Manejo centralizado de errores
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'Ocurrió un error al procesar tu solicitud';

    if (error.error instanceof ErrorEvent) {
      // Error del lado del cliente
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Error del backend
      const apiError = error.error as ApiError;
      if (apiError?.message) {
        errorMessage = apiError.message;
      } else if (error.status === 0) {
        errorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión.';
      } else if (error.status >= 500) {
        errorMessage = 'Error del servidor. Intenta nuevamente más tarde.';
      }
    }

    console.error('❌ Error en la petición:', error);
    return throwError(() => new Error(errorMessage));
  }
}
